/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBingNewsDetailsEntry } from './ExecRiskBingNewsDetailsEntry';
import {
    ExecRiskBingNewsDetailsEntryFromJSON,
    ExecRiskBingNewsDetailsEntryFromJSONTyped,
    ExecRiskBingNewsDetailsEntryToJSON,
} from './ExecRiskBingNewsDetailsEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedBingArticlesResponse
 */
export interface ExecRiskPaginatedBingArticlesResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedBingArticlesResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskBingNewsDetailsEntry>}
     * @memberof ExecRiskPaginatedBingArticlesResponse
     */
    results: Array<ExecRiskBingNewsDetailsEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedBingArticlesResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedBingArticlesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedBingArticlesResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedBingArticlesResponse interface.
 */
export function instanceOfExecRiskPaginatedBingArticlesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedBingArticlesResponseFromJSON(json: any): ExecRiskPaginatedBingArticlesResponse {
    return ExecRiskPaginatedBingArticlesResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedBingArticlesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedBingArticlesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskBingNewsDetailsEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedBingArticlesResponseToJSON(value?: ExecRiskPaginatedBingArticlesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskBingNewsDetailsEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

